import { Collapsible } from '@sgcmpteltd/uikit-react';

import styles from './styles.module.scss';
import type { Component } from './types';

export const OpeningHourList: Component = ({
  children,
  collapseStatus,
  onClick,
}) => (
  <Collapsible
    className={styles.containerRoot}
    isOpen={collapseStatus}
    summary={(
      <button
        className={styles.containerHeader}>
        {children[0]}
      </button>
    )}
    onChange={onClick}>
    <div className={styles.containerContent}>
      {children[1]}
    </div>
  </Collapsible>
);
